module.exports = __webpack_public_path__ + "img/img15.9a34bd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img15.png
// module id = 222
// module chunks = 0